module.exports = __webpack_public_path__ + "static/media/shift_actions.678bec76.png";